// src/pages/mobile/MasPage.tsx
// "Más" screen — grid of secondary modules for mobile bottom tab bar.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, MessageSquare, Users, FolderKanban,
  Columns3, BookOpen, BarChart3, LayoutGrid, Settings,
  type LucideIcon,
} from 'lucide-react';
import { useMobileNavStore } from '@/stores/mobileNavStore';
import { useIsInternal } from '@/stores/authStore';

interface ModuleTile {
  icon: LucideIcon;
  label: string;
  path: string;
  internalOnly?: boolean;
  color: string;
}

const modules: ModuleTile[] = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', color: 'bg-blue-500/10 text-blue-600 dark:text-blue-400' },
  { icon: MessageSquare, label: 'Conversaciones', path: '/conversaciones', color: 'bg-green-500/10 text-green-600 dark:text-green-400' },
  { icon: Users, label: 'Clientes', path: '/clientes', internalOnly: true, color: 'bg-purple-500/10 text-purple-600 dark:text-purple-400' },
  { icon: FolderKanban, label: 'Proyectos', path: '/proyectos', internalOnly: true, color: 'bg-orange-500/10 text-orange-600 dark:text-orange-400' },
  { icon: Columns3, label: 'Kanban', path: '/kanban', internalOnly: true, color: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400' },
  { icon: BookOpen, label: 'Conocimiento', path: '/conocimiento', color: 'bg-teal-500/10 text-teal-600 dark:text-teal-400' },
  { icon: BarChart3, label: 'Reportes', path: '/reportes', internalOnly: true, color: 'bg-pink-500/10 text-pink-600 dark:text-pink-400' },
  { icon: LayoutGrid, label: 'Dashboards', path: '/dashboards', internalOnly: true, color: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400' },
  { icon: Settings, label: 'Config', path: '/configuracion', internalOnly: true, color: 'bg-gray-500/10 text-gray-600 dark:text-gray-400' },
];

export function MasPage() {
  const navigate = useNavigate();
  const isInternal = useIsInternal();
  const { setNavigation } = useMobileNavStore();

  useEffect(() => {
    setNavigation({ title: 'Más' });
  }, [setNavigation]);

  const visibleModules = isInternal
    ? modules
    : modules.filter((m) => !m.internalOnly);

  return (
    <div className="p-4">
      <div className="grid grid-cols-3 gap-3">
        {visibleModules.map((mod) => {
          const Icon = mod.icon;
          return (
            <button
              key={mod.path}
              onClick={() => navigate(mod.path)}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-card border border-border active:bg-muted/50 transition-colors"
            >
              <div className={`flex items-center justify-center w-12 h-12 rounded-xl ${mod.color}`}>
                <Icon className="h-6 w-6" />
              </div>
              <span className="text-xs font-medium text-center">{mod.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
